import { createSelector, createFeatureSelector } from '@ngrx/store';
import { BizShopBannerState } from './biz-shop-banner.reducer';
import { AppState } from '../app.state';

// Feature selector for the BannerState
export const selectBannerState = createFeatureSelector<AppState, BizShopBannerState>('bizShopBanner');



// Selector for biz Banner
export const selectBizShopBanner = createSelector(
  selectBannerState,
  (state: BizShopBannerState) => state.bizShopBanner
);

// Selector for loading state
export const selectBizShopBannerLoading = createSelector(
  selectBannerState,
  (state: BizShopBannerState) => state.loading
);

// Selector for error state
export const selectBizShopError = createSelector(
  selectBannerState,
  (state: BizShopBannerState) => state.error
);
